/**
* Bento Box Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Bento Box Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'bento-box-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.bento-box-grid .divided-content-divider' ).each( function( key, component ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 90%',
            scrub: 0,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => {
              $( this ).addClass( 'is-loaded' );
            },
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'bento-box-grid', COMPONENT );
} )( app );
